import { InstanceResolver } from '@/util/instanceResolver'

export class LineAccountAssociationUrlBuilder {
  constructor(
    private currentPath: string,
    private brandName: string,
    private skuId: string,
    private inquiryKind: string
  ) {}

  public build(): string {
    const path = InstanceResolver.isMulti()
      ? `/${this.brandName}/external_account_association/line/start`
      : `/external_account_association/line/start`
    const query = {
      require_registered: 'false',
      on_success: encodeURI(this.createOnSuccess()),
      on_failure: encodeURI(this.createOnFailure()),
    }

    return this.concatPathAndQuery(path, query)
  }

  /**
   * /api/user/{brand_name}/item/sku/request_notification/hook/{sku_id}?app_kind=line&inquiry_kind={inquiry_kind}
   */
  private createOnSuccess(): string {
    const path = `/api/user/${this.brandName}/item/sku/request_notification/${this.skuId}/hook`
    const query = {
      app_kind: 'line',
      inquiry_kind: this.inquiryKind,
    }

    return this.concatPathAndQuery(path, query)
  }

  /**
   * /{brand_name}/item/{root_id}?message_id=LINE_REQUEST_NOTIFICATION_FAILURE
   */
  private createOnFailure(): string {
    const path = this.currentPath
    const query = {
      message_id: 'LINE_REQUEST_NOTIFICATION_FAILURE',
    }

    return this.concatPathAndQuery(path, query)
  }

  private concatPathAndQuery(path: string, query: { [k: string]: string }): string {
    return `${path}?${new URLSearchParams(query).toString()}`
  }
}
